<template>
  <div>
    <div class="title">
      个人资料
    </div>
    <div class="infoBorder">
      <div class="content">
        <div class="userPic">
          <el-upload class="avatar-uploader" :action="actionUrl" :headers="headers" :show-file-list="false"
            :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
            <img v-if="params.avatarPath" :src="baseUrl + params.avatarPath" class="avatar userImg">
            <img v-else src="../../assets/images/-s-mrtx.png" class="userImg">
            <div class="banyuan">修改头像</div>
          </el-upload>
        </div>
        <div class="info">
          <div>
            <span class="test">您的昵称</span>
            <el-input :style="{'border': flag ? '1px solid #fff' : '1px solid #e6e6e6'}" v-model="params.nickName"
              :placeholder="flag? '':'请输入您的昵称'" :readonly="flag"></el-input>
          </div>
          <div>
            <span class="test">联系电话</span>
            <el-input :style="{'border': flag ? '1px solid #fff' : '1px solid #e6e6e6'}" v-model="params.phone"
              :placeholder="flag? '':'请输入联系电话'" :readonly="flag"></el-input>
          </div>
        </div>
        <div class="info">
          <div>
            <span class="test">真实姓名</span>
            <el-input :style="{'border': flag ? '1px solid #fff' : '1px solid #e6e6e6'}" v-model="params.realname"
              :placeholder="flag? '':'请输入真实姓名'" :readonly="flag"></el-input>
          </div>
          <div>
            <span class="test">公司名称</span>
            <el-input :style="{'border': flag ? '1px solid #fff' : '1px solid #e6e6e6'}" v-model="params.companyName"
              :placeholder="flag? '':'请输入公司名称'" :readonly="flag"></el-input>
          </div>
        </div>
        <div class="info">
          <div>
            <span class="test">密码修改</span>
            <span class="passTest" @click="showChange">修改密码</span>
          </div>
        </div>
      </div>
      <div class="changeInfo" @click="changeInfo">
        <div v-if="flag">
          <img src="../../assets/images/bj@2x.png" class="changeImg">
          <span class="passTest">修改信息</span>
        </div>
        <div v-else class="confirmChange" @click="confirmChange">
          确认修改
        </div>
      </div>
    </div>
    <ChangePass ref="changePassDialog"></ChangePass>
  </div>
</template>

<script>
  import ChangePass from '@/components/ChangePass.vue'
  import {
    serverUrl
  } from '@/utils/server.js'
  import {
    userInfo,
    updateUser
  } from '@/api/api'
  export default {
    data() {
      return {
        flag: true,
        params: {
          avatarPath: '',
          nickName: '',
          phone: '',
          realname: '',
          companyName: ''
        },
        actionUrl: serverUrl.baseURL + "/website/user/updateLogo",
        imageUrl: '',
        baseUrl: serverUrl.baseURL,
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
      }
    },
    components: {
      ChangePass
    },
    mounted() {
      this.getUserInfo()
    },
    methods: {
      childrenData(val) {
      },
      showChange() {
        this.$refs.changePassDialog.openDialog()
      },
      handleAvatarSuccess(res, file) {
        console.log(JSON.stringify(res))
        this.params.avatarPath = res.data.avatar
        this.$emit('childEvent', res.data.avatar);
        var user = JSON.parse(localStorage.getItem('user'))
        console.log(user.avatarPath)
        user.avatarPath = res.data.avatar
        localStorage.setItem('user', JSON.stringify(user))
      },
      beforeAvatarUpload(file) {
        // const isJPG = file.type === 'image/jpeg';
        // const isLt2M = file.size / 1024 / 1024 < 2;

        // if (!isJPG) {
        //   this.$message.error('上传头像图片只能是 JPG 格式!');
        // }
        // if (!isLt2M) {
        //   this.$message.error('上传头像图片大小不能超过 2MB!');
        // }
        // return isJPG && isLt2M;
      },

      getUserInfo() {
        userInfo().then(res => {
          this.params = res.data
        })
      },
      changeInfo() {
        this.flag = !this.flag
      },
      confirmChange() {
        if (!this.params.nickName) {
          this.flag = true
          return this.$message({
            message: '请填写昵称！',
            type: 'warning'
          });
        }
        var data = {
          nickName: this.params.nickName,
          phone: this.params.phone,
          realname: this.params.realname,
          companyName: this.params.companyName
        }
        updateUser(data).then(res => {
          this.getUserInfo()
          this.$message({
            message: '修改成功！',
            type: 'success'
          });
        })
      }
    }
  }
</script>

<style scoped>
  .title {
    height: 66px;
    line-height: 66px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #282F3D;
    padding-left: 30px;
    background: #fff;
  }

  .infoBorder {
    margin: 25px 0 0 25px;
    width: 95%;
    height: 160px;
    background: #FFFFFF;
    box-shadow: 1px 3px 16px 0px rgba(204, 211, 228, 0.51);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .infoBorder>.content {
    width: 90%;
    display: flex;
    justify-content: flex-start;
  }

  .info {
    line-height: 52px;
    width: 28%;
  }

  .info>div {
    display: flex;
    align-items: center;
  }

  .userPic {
    cursor: pointer;
    width: 103px;
    height: 103px;
    margin-right: 50px;
    position: relative;
  }

  .userImg {
    width: 103px;
    height: 103px;
    border-radius: 50%;
  }

  .userPic:hover .banyuan {
    display: block;
    transition: all 0.5s;
    /* transform: scale(1); */
  }

  .banyuan {
    text-align: center;
    line-height: 103px;
    color: #fff;
    font-size: 14px;
    width: 103px;
    height: 103px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    position: absolute;
    top: 0px;
    display: none;
    transition: all 0.5s;
  }

  .test {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #909DB1;
    display: inline-block;
    width: 80px;
  }

  .changeImg {
    width: 16px;
    height: 15px;
    margin-right: 10px;
  }

  .passTest {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #0F5EFF;
    cursor: pointer;
  }

  .changeInfo {
    position: absolute;
    right: 40px;
    top: 15px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  /deep/ .el-input__inner {
    width: 100%;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
    border: none;
    border-radius: 10px;
  }

  .info>div {
    display: flex;
    justify-content: flex-start;
  }

  .confirmChange {
    color: #fff;
    background: #0F5EFF;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
  }

  .el-input {
    height: 40px;
    line-height: 40px;
    border-radius: 10px;
    width: 60%;
  }
</style>



// WEBPACK FOOTER //
// src/views/console/PersonalData.vue